import React, { useState, useEffect } from 'react';
import "../../css/Routine.css";
import Loader from "../../components/Loader";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaCalendarAlt, FaClock, FaChalkboardTeacher, FaUserGraduate } from 'react-icons/fa';

function StudentRoutine() {
    const [routine, setRoutine] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const weekDays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

    useEffect(() => {
        fetchMyRoutine();
    }, []);

    const fetchMyRoutine = async () => {
        const token = localStorage.getItem("token");
        if (!token) {
            toast.error("Unauthorized! Please log in again.");
            return;
        }

        setIsLoading(true);

        try {
            const response = await fetch("https://schoolpro-api.uniums.com/api/student/routines/my-routine", {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || "Failed to fetch routine");
            }

            const data = await response.json();
            setRoutine(data.routine);
        } catch (error) {
            console.error("Error fetching routine:", error);
            toast.error(`Error: ${error.message}`);
        } finally {
            setIsLoading(false);
        }
    };

    const sortPeriods = (periods) => {
        return [...periods].sort((a, b) => {
            const timeA = new Date(`2000-01-01T${a.startTime}`);
            const timeB = new Date(`2000-01-01T${b.startTime}`);
            return timeA - timeB;
        });
    };

    const getDayName = (day) => {
        const days = {
            monday: "Monday",
            tuesday: "Tuesday",
            wednesday: "Wednesday",
            thursday: "Thursday",
            friday: "Friday",
            saturday: "Saturday"
        };
        return days[day] || day;
    };

    const renderRoutineSchedule = () => {
        if (!routine) return null;

        return (
            <div className="routine-schedule">
                <div className="routine-schedule-header">
                    <h2>
                        <FaChalkboardTeacher className="routine-header-icon" />
                        Class Routine: {routine.classId.name} - {routine.classId.section}
                    </h2>
                </div>

                <div className="routine-days-container">
                    {weekDays.map(day => {
                        const periods = routine.schedule[day] || [];
                        const sortedPeriods = sortPeriods(periods);

                        return (
                            <div key={day} className="routine-day-card">
                                <div className="routine-day-header">
                                    <h3>{getDayName(day)}</h3>
                                    <span className="routine-period-count">
                                        {periods.length} {periods.length === 1 ? 'period' : 'periods'}
                                    </span>
                                </div>

                                <div className="routine-periods-list">
                                    {sortedPeriods.length === 0 ? (
                                        <div className="routine-no-periods">
                                            <p>No classes scheduled</p>
                                        </div>
                                    ) : (
                                        sortedPeriods.map((period, index) => (
                                            <div key={index} className="routine-period-item">
                                                <div className="routine-period-time">
                                                    <FaClock className="routine-time-icon" />
                                                    <span>{period.startTime} - {period.endTime}</span>
                                                </div>
                                                <div className="routine-period-info">
                                                    <h4 className="routine-subject">{period.subject}</h4>
                                                    <p className="routine-teacher">
                                                        <FaUserGraduate className="routine-teacher-icon" />
                                                        {period.teacher}
                                                    </p>
                                                </div>
                                            </div>
                                        ))
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    };

    return (
        <div className="routine-container">
            <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} />
            {isLoading && <Loader />}

            <div className="routine-header">
                <div className="routine-title-container">
                    <FaCalendarAlt className="routine-title-icon" />
                    <h1 className="routine-title">My Class Routine</h1>
                </div>
            </div>

            {routine ? renderRoutineSchedule() : (
                !isLoading && <p style={{ textAlign: "center", marginTop: "20px" }}>No routine found for your class.</p>
            )}
        </div>
    );
}

export default StudentRoutine;
